import { useEffect } from "react";

import { Login } from "./components/Login.js";
import { Workspace } from "./components/Workspace.js";
import { useStore } from "./store.js";

export function App() {
  const status = useStore((state) => state.status);
  const init = useStore((state) => state.init);

  useEffect(() => {
    void init();
  }, [init]);

  if (status === "loading") {
    return (
      <div className="flex h-full items-center justify-center text-ink-muted">
        <p>Loading your canvas...</p>
      </div>
    );
  }

  if (status === "anonymous") {
    return <Login />;
  }

  return <Workspace />;
}
